import { MutationTree } from 'vuex'
import { SnackState, Snack } from './snack.types'

export enum MutationTypes {
  SET_SNACK = 'SET_SNACK'
}

export const mutations: MutationTree<SnackState> = {
  [MutationTypes.SET_SNACK](state, { val, text, variant, timeout }: Snack) {
    if (val === undefined) val = true
    if (!variant) variant = 'error'
    if (!timeout) {
      timeout = variant === 'error' ? -1 : 3000
    }
    state.snack = { val, text, variant, timeout }
  }
}
